<template>
  <b-container>
    <Wts/>
  </b-container>
</template>

<script>
import Wts from '@/components/WTS.vue'

export default {
  name: 'dictionary',
  components: {
    Wts
  },
}
</script>